import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=e61b95e0&scoped=true&"
import script from "./FooterComponent.vue?vue&type=script&lang=ts&"
export * from "./FooterComponent.vue?vue&type=script&lang=ts&"
import style1 from "./FooterComponent.vue?vue&type=style&index=1&id=e61b95e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61b95e0",
  null
  
)

export default component.exports